import React from 'react';
import EmailFieldProto from './email-proto';


export default function renderStringInFormNew(id, props) {
    return <EmailFieldProto renderMode="form-new" id={id} {...props} />;
}